import React from 'react';

const Intro = () => {


  return (
    <div className="overflow-hidden">
      {/* Hero Section */} 

    <section className="relative w-full min-h-[80vh] flex items-end justify-start overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            "url('https://ik.imagekit.io/7wqj9br0b/KapilTech_Website_Staffing/About%20US/Kapil%20About%20us.png')",
        }}
      ></div>

      {/* Dark Overlay */}
      <div
        className="absolute inset-0"
      ></div>

      {/* Content */}
      <div className="relative z-10 w-full mx-0 px-6 md:px-12 lg:px-20 py-12 w-full text-left">
        <h1
          className="text-3xl md:text-4xl lg:text-5xl font-semibold leading-tight tracking-tight"
          style={{ color: '#ffffff' }}
        >
          Empowering Global Businesses <br/><span className='block mt-1'>
           with Exceptional Talent</span>
        </h1>
      </div>
    </section>
    </div>
  );
};

export default Intro;
